import * as React from 'react';
import { DateRangePicker } from 'materialui-daterange-picker';
import * as moment from 'moment';
import './Datepicker.scss';
import CalenderPicker from '../../../../assets/calendarPicker';
import i18n from 'src/translation/i18n';
const DateRangeSelector = (props: any) => {
  const {
    isReset,
    open,
    toggle,
    setCurrentDateRange,
    dateRange,
    handleDatePickerApply
  } = props;

  const definedDateRange: any = [
    {
      label: i18n.t('invoices.today'),
      startDate: new Date(),
      endDate: new Date()
    },
    {
      label: i18n.t('invoices.lastWeek'),
      startDate: moment()
        .subtract(1, 'weeks')
        .startOf('week'),
      endDate: moment()
        .subtract(1, 'weeks')
        .endOf('week')
    },
    {
      label: i18n.t('invoices.monthtoDate'),
      startDate: moment().startOf('month'),
      endDate: moment().subtract(1, 'days')
    },
    {
      label: i18n.t('invoices.priorMonth'),
      startDate: moment()
        .subtract(1, 'months')
        .startOf('month'),
      endDate: moment()
        .subtract(1, 'months')
        .endOf('month')
    },
    {
      label: i18n.t('invoices.lastThreeMonths'),
      startDate: moment().subtract(3, 'months'),
      endDate: new Date()
    }
  ];

  function isEmpty(obj: any) {
    return Object.keys(obj).length === 0;
  }
  const sdate = moment(dateRange['startDate']).format('MM/DD/YYYY');
  const edate = moment(dateRange['endDate']).format('MM/DD/YYYY');
  return (
    <div className="rp-date-range">
      <div className="date-range--date-picker" onClick={toggle}>
        <span className="date-label">
          {isEmpty(dateRange) || isReset
            ? i18n.t('invoices.startDateEndDate')
            : sdate + ' | ' + edate}
        </span>
        {/* <i className="rpds-calendar-today" /> */}
        <img className="calender-picker" src={CalenderPicker} />
        {open && (
          <button
            className="btn date-filter-apply"
            onClick={() => handleDatePickerApply(dateRange)}
          >
            {i18n.t('invoices.apply')}
          </button>
        )}
      </div>
      <DateRangePicker
        open={open}
        toggle={toggle}
        initialDateRange={dateRange}
        onChange={range => setCurrentDateRange(range)}
        definedRanges={definedDateRange}
        closeOnClickOutside={true}
        wrapperClassName="dateRanger"
      />
    </div>
  );
};

export default DateRangeSelector;
